import { FC, SyntheticEvent } from 'react';
import { useTranslation } from 'next-i18next';
import { Select as SelectAntd, SelectProps } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
export type { SelectProps } from 'antd';

export const Select: FC<SelectProps> = ({ placeholder, ...props }) => {
  const { t } = useTranslation('common');

  const handleClear = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    props.onChange?.([], {});
  };

  return (
    <StyledSelect
      maxTagCount="responsive"
      removeIcon={<Icon name="x" size="s16" />}
      showSearch={false}
      maxTagPlaceholder={(omittedValues) => (
        <OverflowItemContainer>
          <span>
            {t('selected')}: {omittedValues.length}
          </span>
          <ClearButton onMouseDown={handleClear}>
            <Icon name="x" size="s16" />
          </ClearButton>
        </OverflowItemContainer>
      )}
      placeholder={placeholder}
      {...props}
    />
  );
};

const StyledSelect = styled(SelectAntd)`
  width: 100%;

  &&&.ant-select-multiple:hover .ant-select-selector,
  &&&.ant-select-multiple.ant-select-focused .ant-select-selector {
    border-color: ${COLORS.systemSky200} !important;
    box-shadow: none !important;
  }

  &&&.ant-select-multiple .ant-select-selector {
    padding-left: 12px;
  }

  &&&.ant-select-multiple .ant-select-selection-item {
    background-color: ${COLORS.systemSky100};
    height: 20px;
    align-items: center;
  }

  &&& .ant-select-selection-overflow-item-rest {
    flex-basis: 100%;
  }

  &&& .ant-select-selection-item-remove {
    color: ${COLORS.systemDark200};
  }

  &&& .ant-select-selection-item-remove:hover {
    color: ${COLORS.systemDark300};
  }
`;

const OverflowItemContainer = styled.div`
  display: inline-flex;
  gap: 2px;
  align-items: center;
  line-height: 20px;
`;

const ClearButton = styled.button`
  background: transparent;
  padding: 0;
  border: none;
  outline: none;
  color: ${COLORS.systemDark200};
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: ${COLORS.systemDark300};
  }
`;
